import useAuth from 'hooks/useAuth';
import { dispatch } from 'store';
import { setLastSaved } from 'store/reducers/ui';

export default function useSetPath() {
  const firebase = useAuth();

  const setPath = async (path: string, value: any) => {
    const normalizedPath = typeof path === 'string' ? path.trim() : '';
    const hasValidDocPath =
      normalizedPath.length > 0 &&
      !normalizedPath.startsWith('/') &&
      !normalizedPath.endsWith('/') &&
      normalizedPath.split('/').filter(Boolean).length % 2 === 0;

    if (!hasValidDocPath) {
      console.warn('useSetPath called with invalid Firestore doc path', { path });
      return;
    }

    try {
      return await firebase.db.doc(normalizedPath).set(value, { merge: true });
    } catch (err) {
      console.log(err);
    } finally {
      dispatch(setLastSaved(new Date()));
    }
  };

  return setPath;
}
